import { HttpErrorResponse } from '@angular/common/http';

/**
 * Status 0 means the request never got an HTTP response: offline, a mobile
 * OS suspending the app mid-request, or a navigation aborting it. There is
 * nothing for Sentry to act on, unlike a real 4xx/5xx from the backend.
 */
export function isNoResponseHttpError(error: unknown): boolean {
  return error instanceof HttpErrorResponse && error.status === 0;
}
